import Leaf from './Leaf';

export default Leaf;
